<template lang="pug">
.v-map.map
	.map__map(ref="map")
</template>

<script>
import controller from '../scripts/controller/controller';
import mitt from 'mitt';

let map = null;
let mapMarkers = [];

export default {
	props: {
		coords: {
			type: Array,
			validator(val) {
				return val && val.length === 2 && typeof val[0] == 'number' && typeof val[1] == 'number' && !isNaN(val[0]) && !isNaN(val[1]);
			},
			default() {
				return [52.417403, 30.963880];
			}
		},

		zoom: {
			type: Number,
			validator(val) {
				return !isNaN(val);
			},
			default: 17
		},

		adjustInitialBounds: {
			type: Boolean,
			default: true
		},

		rightControls: {
			type: Boolean,
			default: false
		},

		clusters: {
			type: Boolean,
			default: false
		},

		markers: {
			type: Array,
			default: null
		}
	},

	data() {
		return {
			currentLocation: null,
			events: mitt()
		};
	},

	watch: {
		coords(newValue) {
			if (map) {
				map.setCenter(newValue);
			}
		},

		markers() {
			if (map) {
				this.setMarkers();
			}
		}
	},

	async mounted() {
		this.events.on('adjust-bounds', this.adjustBounds);
		this.events.on('open-balloon', (index) => {
			if (mapMarkers) {
				mapMarkers[index].balloon.open();
			}
		});
		this.events.on('highlight-balloon', (index) => {
			if (mapMarkers && mapMarkers[index]) {
				mapMarkers[index].options.set('iconImageHref', '/local/assets/images/map-marker-highlight.svg');
			}
		});
		this.events.on('unhighlight-balloon', (index) => {
			if (mapMarkers && mapMarkers[index]) {
				mapMarkers[index].options.set('iconImageHref', '/local/assets/images/map-marker-default.svg');
			}
		});
		this.events.on('set-route-to', this.makeRoute);
		this.events.on('refresh', this.setMarkers);
		await this.$store.dispatch('location/loadAPI');
		this.initMap();
	},

	methods: {
		shownOnMap(coords) {
			map.setCenter(coords);
			map.setZoom(17);
		},
		
		//showCurrentBallon(index) {
		//	mapMarkers[index].balloon.open();
		//},

		// Прокладывает маршрут
		makeRoute(point) {
			// eslint-disable-next-line no-undef
			ymaps.geolocation.get({
				provider: 'auto', // опция для определения положения по ip
				autoReverseGeocode: true // автоматическое геокодируем полученного результата
			}).then((result) => {
				this.currentLocation = /*this.$store.getters['location/coords'] ||*/ result.geoObjects.get(0).geometry.getCoordinates();
				if (point) {
					// eslint-disable-next-line no-undef
					let multiRoute = new ymaps.multiRouter.MultiRoute({
						// точки маршрута (могут быть заданы как координатами, так и адресом)
						referencePoints: [
							this.currentLocation,
							point
						]
					}, {
						boundsAutoApply: true
					});
					if (multiRoute) {
						map.geoObjects.removeAll();
						this.setMarkers();
						map.geoObjects.add(multiRoute);
					}
				} else {
					return false;
				}
			});
		},

		adjustBounds() {
			if (map) {
				this.setMarkers();
				try {
					this.setBounds(map.geoObjects.getBounds(), {checkZoomRange: true}).then(() => {
						if (map.getZoom() > 16) {
							map.setZoom(16);
						}
					});
				} catch (e) {}
			}
		},

		getBaloonContent(marker) {
			let markerTypeTemplate = '';
			let markerNameTemplate = '';
			let markerDescrTemplate = '';
			let transportTemplate = '';
			let scheduleTemplate = '';
			let phonesTemplate = '';
			if (marker.type) {
				markerTypeTemplate += `<div class="map__balloon-type">${marker.type}</div>`;
			}
			if (marker.name) {
				markerNameTemplate += `<div class="map__balloon-name">${marker.name}</div>`;
			}
			if (marker.descr) {
				markerDescrTemplate += `<div class="map__balloon-descr">${marker.descr}</div>`;
			}
			if (marker.transport && marker.transport.length) {
				for (let transportItem of marker.transport) {
					let transporTypeIcon = '';
					if (transportItem.type) {
						transporTypeIcon += `
							<svg class="svg-icon map__balloon-icon">
								<use xlink:href="#svg-icon-${transportItem.type}"></use>
							</svg>
						`;
					}
					transportTemplate += `
						<div class="map__balloon-line">
							${transporTypeIcon}
							<div class="map__balloon-text">${transportItem.text}</div>
						</div>
					`;
				}
			}
			if (marker.schedule && marker.schedule.length) {
				scheduleTemplate = `
					<div class="map__balloon-line">
						<svg class="svg-icon map__balloon-icon">
							<use xlink:href="#svg-icon-time"></use>
						</svg>
						<div class="map__balloon-text">${marker.schedule}</div>
					</div>
				`;
			}
			if (marker.phones && marker.phones.length) {
				let phonesTemplateItem = '';
				for (let phonestItem of marker.phones) {
					phonesTemplateItem += `
						<div class="map__balloon-text">${phonestItem.text};&nbsp;</div>
					`;
				}
				phonesTemplate += `
					<div class="map__balloon-line">
						<svg class="svg-icon map__balloon-icon">
							<use xlink:href="#svg-icon-phone-2"></use>
						</svg>
						<div class="map__balloon-text-wrap">
							${phonesTemplateItem}
						</div>
					</div>
				`;
			}
			return `
				<div class="map__balloon">
					${markerTypeTemplate}
					${markerNameTemplate}
					${markerDescrTemplate}
					<div class="map__balloon-lines">
						${transportTemplate}
						${scheduleTemplate}
						${phonesTemplate}
					</div>
				</div>
			`;
		},

		setMarkers() {
			// clear map
			map.geoObjects.removeAll();
			mapMarkers.splice(0, mapMarkers.length);
			// create ymaps markers
			if (this.markers) {
				this.markers.forEach((marker) => {
					let markerType = capitalize(marker.markerType) || 'Placemark';
					let properties = {
						hintContent: marker.hintContent || null,
						//balloonContentHeader: marker.type || null,
						balloonContentBody: this.getBaloonContent(marker) || null,
						//balloonContentFooter: marker.balloonFooter || null,
						//iconContent: getIconHtml(marker.pinNum, marker.pinAlt)
					};
					let iconImageWidth = 58;
					let iconImageHeight = 64;
					let options = {
						id: marker.id,
						iconLayout: 'default#imageWithContent',
						iconImageHref: '/local/assets/images/map-marker-default.svg',
						iconImageSize: [iconImageWidth, iconImageHeight],
						iconImageOffset: [-iconImageWidth / 2, -iconImageHeight],
						hideIconOnBalloonOpen: false
						//balloonShadow: false,
						//balloonLayout: MyBalloonLayout,
						//balloonContentLayout: MyBalloonContentLayout,
						//balloonPanelMaxMapArea: 0
					};
					// eslint-disable-next-line no-undef
					let ymarker = new ymaps[markerType](sanitizeCoords(marker.coords), properties, options);
					map.geoObjects.add(ymarker);
					mapMarkers.push(ymarker);
					// use clusterization
					if (this.clusters) {
						// eslint-disable-next-line no-undef
						let clusterer = new ymaps.Clusterer({
							// clusterIcons: [
							// 	{
							// 		href: '/local/images/markup-images/icons/pin_light.png',
							// 		size: [60, 60],
							// 		offset: [-30, -30]
							// 	}
							// ],
							clusterNumbers: [10],
							//clusterIconContentLayout: clusterIconLayout,
							preset: 'islands#invertedBlueClusterIcons',
							groupByCoordinates: false,
							//clusterDisableClickZoom: true,
							clusterHideIconOnBalloonOpen: true,
							geoObjectHideIconOnBalloonOpen: true,
							gridSize: 80,
						});
						clusterer.add(ymarker);
						this.map.geoObjects.add(clusterer);
					}
				});
			}
			function capitalize(string) {
				return string ? string.charAt(0).toUpperCase() + string.slice(1) : string;
			}
			function sanitizeCoords(arr) {
				return arr.map(function (item) {
					return Array.isArray(item) ? sanitizeCoords(item) : +item;
				});
			}
		},

		initMap() {
			// eslint-disable-next-line no-undef
			map = new ymaps.Map(this.$refs['map'], {
				center: this.coords,
				zoom: +this.zoom,
				controls: ['fullscreenControl', 'geolocationControl']
			},
			{
				balloonPanelMaxMapArea: 0	// always show balloons as balloons (no panel mode)
			});
			map.behaviors.disable('scrollZoom');
			if (this.rightControls) {
				map.controls.add('zoomControl', {
					position: {
						right: '10px',
						top: '108px'
					}
				});
			} else {
				map.controls.add('zoomControl', {
					position: {
						left: '10px',
						top: '108px'
					}
				});
			}
			if (controller.touch) {
				map.behaviors.disable('drag');
			}
			this.setMarkers();
			if (this.adjustInitialBounds) {
				this.adjustBounds();
			}
			//map.geoObjects.events.add('balloonopen', (e) => {
			//	console.log('b o', e);
			//});
			//map.geoObjects.events.add('balloonclose', (e) => {
			//	console.log('b c', e.get('target'));
			//});
		}
	}
};
</script>